import Component from 'flarum/common/Component';
import avatar from 'flarum/common/helpers/avatar';
import app from 'flarum/forum/app';
import CustomAvatarEditor from './CustomAvatarEditor';

export default class UserProfilePanel extends Component {
  view() {
    const user = this.attrs.user;
    if (!user) return null;

    // 获取积分数据 - 使用 remote_points
    let remotePoints = 0;
    if (user.data && user.data.attributes) {
      remotePoints = user.data.attributes.remote_points || 0;
    } else if (typeof user.attributes === 'function') {
      remotePoints = user.attributes().remote_points || 0;
    }
    
    // 格式化日期为 "26 Sep, 2025" 格式
    const formatJoinDate = (date) => {
      if (!date) return '';
      // dayjs 是全局可用的
      const d = window.dayjs(date);
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      return `${d.date()} ${months[d.month()]}, ${d.year()}`;
    };

    // 获取上次登录时间（相对时间）
    const getLastLogin = () => {
      if (!user.lastSeenAt || typeof user.lastSeenAt !== 'function') return '';
      const lastSeen = user.lastSeenAt();
      if (!lastSeen) return '';
      // dayjs 是全局可用的，relativeTime 插件已加载
      return window.dayjs(lastSeen).fromNow();
    };

    // 获取加入时间
    const getJoinDate = () => {
      if (!user.joinTime || typeof user.joinTime !== 'function') return '';
      const joinTime = user.joinTime();
      if (!joinTime) return '';
      return formatJoinDate(joinTime);
    };

    // 检查是否是当前登录用户（可以编辑头像）
    const isCurrentUser = app.session.user && app.session.user.id() === user.id();

    return (
      <div className="UserProfilePanel">
        <div className="UserProfilePanel-avatar">
          {isCurrentUser ? (
            <CustomAvatarEditor user={user} className="UserProfilePanel-avatar-editor" />
          ) : (
            avatar(user, { className: 'UserProfilePanel-avatar-img' })
          )}
        </div>
        <div className="UserProfilePanel-info">
          {!isCurrentUser && (
            <div className="UserProfilePanel-name">{user.displayName()}</div>
          )}
          
          <div className="UserProfilePanel-points-section">
            <div className="UserProfilePanel-points-label">
              {app.translator.trans('tf-custom-profile.forum.profile.current_points')}
            </div>
            <div className="UserProfilePanel-points-value">
              {remotePoints.toLocaleString()}
            </div>
          </div>

          <div className="UserProfilePanel-meta">
            <div className="UserProfilePanel-meta-item">
              <span className="UserProfilePanel-meta-label">
                {app.translator.trans('tf-custom-profile.forum.profile.last_login')}
              </span>
              <span className="UserProfilePanel-meta-value">{getLastLogin()}</span>
            </div>
            <div className="UserProfilePanel-meta-item">
              <span className="UserProfilePanel-meta-label">
                {app.translator.trans('tf-custom-profile.forum.profile.joined_community')}
              </span>
              <span className="UserProfilePanel-meta-value">{getJoinDate()}</span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

